import React from "react";

const SlideHeader = ({ title, onClickClose }) => {
  return (
    <div className="flex justify-between border-b border-[--table_border] px-4 py-6">
      <h2 className=" text-[--title_color] text-[20px] font-medium  text-lg font-bold">
       {title}
      </h2>
      <button className="w-9 text-xl" onClick={onClickClose}>✕</button>
    </div>
  );
};

export default SlideHeader;
